import axios from 'axios';

const supporters = {
    // Search supporter (topbar)
    async search(text) {
        return axios.get(`/supporters/search?text=${text}`);
    },
    // Get supporter by id (supporter detail page)
    async get(id) { 
        return axios.get(`/supporters/get?id=${id}`)
    },
    // Get all donations for a supporter by supporter id
    async getDonations(supporterId) {
        return axios.get(`/supporters/donations?supporterId=${supporterId}`);
    }
};

export default supporters;